import React from 'react';
import { Container, Typography, Paper, Box, Divider } from '@mui/material';
import Seo from '../components/common/Seo';

const Section = ({ title, children }) => (
    <Box sx={{ mt: 4 }}>
        <Typography variant="h6" fontWeight={700} gutterBottom>
            {title}
        </Typography>
        {children}
    </Box>
);

const P = ({ children }) => (
    <Typography variant="body1" paragraph sx={{ lineHeight: 2 }}>
        {children}
    </Typography>
);

function Terms() {
    return (
        <>
            <Seo
                title="利用規約"
                description="Room Share Matchingの利用規約について。当サービスをご利用いただく際の規約やルールを詳しく説明しています。"
                path="/terms"
                keywords="利用規約,サービス規約,Room Share Matching,ルール,ガイドライン"
            />
            <Container maxWidth="md">
                <Paper sx={{ p: { xs: 3, md: 5 }, mt: 4, mb: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom fontWeight={700}>
                        利用規約
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        制定：2024年3月1日　最終改訂：2026年4月11日
                    </Typography>
                    <Divider sx={{ mt: 2, mb: 3 }} />

                    <P>
                        この利用規約（以下「本規約」といいます。）は、本サービス提供者が提供する「ルームシェアマッチング」（以下「本サービス」といいます。）の利用条件を定めるものです。ユーザーの皆さまには、本規約に従って本サービスをご利用いただきます。本サービスを利用した時点で、本規約の全条項に同意したものとみなします。
                    </P>

                    <Section title="第1条（サービスの性質・当事者関係）">
                        <P>
                            1. 本サービスは、部屋の貸し手と借り手をつなぐオンライン上のマッチングプラットフォームを提供するものであり、本サービス提供者は当事者間の物件賃貸借契約、ルームシェア契約、その他いかなる契約にも当事者として関与しません。<br />
                            2. 本サービス提供者は宅地建物取引業者ではなく、物件の仲介・媒介を行うものではありません。掲載される物件情報はユーザーが自ら登録したものであり、本サービス提供者は掲載内容に責任を負いません。<br />
                            3. ユーザー間で成立する一切の合意・契約・取引はユーザー間の直接の法律関係であり、本サービス提供者はその当事者ではありません。
                        </P>
                    </Section>

                    <Section title="第2条（適用）">
                        <P>
                            1. 本規約は、ユーザーと本サービス提供者との間の本サービスの利用に関わる一切の関係に適用されます。<br />
                            2. 本サービス提供者は本サービスに関し、本規約のほかに個別のガイドラインや注意事項等を定めることがあります。これらは本規約の一部を構成します。本規約と個別規定が矛盾する場合は本規約が優先します。<br />
                            3. 本規約の一部が法令上無効とされた場合でも、その他の部分は引き続き有効とします。
                        </P>
                    </Section>

                    <Section title="第3条（利用登録）">
                        <P>
                            1. 本サービスの利用登録は、登録希望者が本規約に同意の上、本サービスの定める手順（メールアドレス登録・メール認証等）を完了することにより成立します。本サービス提供者による個別の承認手続きは存在しません。<br />
                            2. 本サービス提供者は、以下の事由があると判断した場合、登録完了後であっても事前通知なくアカウントを停止・抹消することがあります。その理由については一切の開示義務を負いません。<br />
                            ・登録内容に虚偽・誤記・記載漏れがある場合<br />
                            ・過去に本規約違反等でアカウント停止・抹消となった者による登録の場合<br />
                            ・未成年者で親権者の同意がない場合<br />
                            ・反社会的勢力に該当すると判断した場合<br />
                            ・その他本サービス提供者が不適切と判断した場合<br />
                            3. 登録情報・ログイン情報の管理はユーザー自身の責任で行うものとします。ログイン情報の第三者への漏洩・不正利用によって生じた損害について、本サービス提供者は一切責任を負いません。
                        </P>
                    </Section>

                    <Section title="第4条（禁止事項）">
                        <P>
                            ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。違反した場合、本サービス提供者は事前通知なく当該ユーザーの利用停止・登録抹消・法的措置等を講じることができます。<br />
                            1. 法令または公序良俗に違反する行為<br />
                            2. 犯罪行為に関連する行為<br />
                            3. 架空・虚偽の物件情報・プロフィール情報の登録<br />
                            4. 実際には存在しない物件の掲載（おとり広告）<br />
                            5. 詐欺・恐喝・ハラスメント・ストーキング行為<br />
                            6. 他のユーザーへの勧誘・営業・宗教・マルチ商法等の勧誘行為<br />
                            7. 本サービス外での金銭授受を目的とした行為<br />
                            8. 他のユーザーの個人情報を無断で収集・蓄積・第三者提供する行為<br />
                            9. 他のユーザーに成りすます行為<br />
                            10. 本サービスのサーバー・ネットワークの機能を妨害する行為<br />
                            11. 本サービスのスクレイピング・自動取得行為<br />
                            12. 反社会的勢力への利益供与<br />
                            13. その他本サービス提供者が不適切と判断した行為
                        </P>
                    </Section>

                    <Section title="第5条（対面・内見・実際の接触に関する注意と免責）">
                        <P>
                            1. ユーザーが本サービスを通じて知り合った他のユーザーと実際に対面・内見・交流する場合は、完全にユーザー自身の判断と責任において行うものとします。<br />
                            2. 本サービス提供者は、ユーザー間の対面・内見・交流・契約締結の場に一切関与せず、それによって生じた人身事故・財産的損害・精神的苦痛・その他いかなる損害についても、一切責任を負いません。<br />
                            3. 本サービス提供者は、他のユーザーの身元・本人確認・信用情報を保証するものではありません。ユーザーは、相手方の情報を鵜呑みにすることなく、自己の判断で慎重に行動してください。<br />
                            4. 物件の実際の状態・設備・周辺環境等は、ユーザー自身が実地確認する責任を負います。本サービス提供者は物件情報の真偽・正確性・最新性を保証しません。
                        </P>
                    </Section>

                    <Section title="第6条（本サービスの提供の停止・変更・終了）">
                        <P>
                            1. 本サービス提供者は、以下のいずれかの事由があると判断した場合はもとより、理由の如何を問わず、ユーザーへの事前通知なく本サービスの全部または一部の提供を停止・中断・変更・終了することができます。<br />
                            ・システムの保守点検・更新を行う場合<br />
                            ・地震・落雷・火災・停電・自然災害・感染症・その他不可抗力により提供が困難となった場合<br />
                            ・外部サービスの障害・仕様変更による場合<br />
                            ・コンピューターへの不正アクセス・ウイルス感染等による場合<br />
                            ・経営上の都合その他本サービス提供者が必要と判断した場合<br />
                            2. 本サービスの停止・中断・変更・終了によってユーザーに生じた損害（登録データの消失を含む）について、本サービス提供者は一切の責任を負いません。
                        </P>
                    </Section>

                    <Section title="第7条（利用制限および登録抹消）">
                        <P>
                            1. 本サービス提供者は、ユーザーが以下のいずれかに該当する場合はもとより、本サービス提供者が必要と判断したときはいつでも、事前の通知なく、本サービスの全部もしくは一部の利用を制限し、またはアカウントを停止・登録を抹消することができます。<br />
                            ・本規約のいずれかの条項に違反した場合<br />
                            ・登録事項に虚偽の事実があることが判明した場合<br />
                            ・本サービス提供者からの連絡に対し一定期間返答がない場合<br />
                            ・長期間ログインがなく休眠状態にあると判断した場合<br />
                            ・その他本サービス提供者が利用継続を不適切と判断した場合<br />
                            2. 前項の措置によってユーザーに生じた損害（投稿データ・マッチング情報の消失等を含む）について、本サービス提供者は一切の責任を負いません。
                        </P>
                    </Section>

                    <Section title="第8条（免責事項）">
                        <P>
                            1. 本サービス提供者は、本サービスの内容（掲載物件・ユーザー情報を含む）の正確性・完全性・有用性・合法性・最新性について、いかなる保証も行いません。<br />
                            2. 本サービス提供者は、本サービスを通じてユーザーと他のユーザーまたは第三者との間において生じた取引・連絡・紛争・トラブルについて一切責任を負いません。これには詐欺・ハラスメント・不法行為を含みますが、これらに限りません。<br />
                            3. 本サービス提供者の故意または重大な過失によらない限り、本サービスに関する債務不履行責任・不法行為責任その他一切の法的責任は免責されます。<br />
                            4. 本サービス提供者がユーザーに対して損害賠償責任を負う場合であっても、その賠償額は、当該ユーザーが本サービス提供者に支払った直近1ヶ月分の利用料金（無料プランの場合は金0円）を上限とします。<br />
                            5. 本サービス提供者は、間接損害・特別損害・結果的損害・逸失利益・機会損失については、予見可能性の有無にかかわらず、一切責任を負いません。<br />
                            6. 本サービスはルームシェアの「マッチング機会」を提供するものであり、特定のマッチング成立・物件取得・契約締結を保証するものではありません。<br />
                            7. 本サービスからリンクされた第三者のウェブサイト・サービスについて、本サービス提供者は一切責任を負いません。<br />
                            8. 本サービス提供者は、天災・法令の制定・改廃・感染症・その他不可抗力による本サービスの変更・停止・損害について責任を負いません。
                        </P>
                    </Section>

                    <Section title="第9条（個人情報・セキュリティに関する免責）">
                        <P>
                            1. 本サービス提供者は、別途定めるプライバシーポリシーに従い個人情報の適切な管理に努めますが、以下の場合に生じた個人情報の漏洩・滅失・毀損等について、一切の責任を負いません。<br />
                            ・ユーザー自身の操作ミス・不注意による漏洩<br />
                            ・第三者による不正アクセス・ハッキング・マルウェア等による漏洩<br />
                            ・外部サービス（認証基盤・クラウドサービス等）の障害・セキュリティ侵害による漏洩<br />
                            ・通信経路上での傍受その他技術的に防止が困難な事由による漏洩<br />
                            ・その他本サービス提供者の故意または重大な過失によらない事由による漏洩<br />
                            2. ユーザーは、本サービスに登録する情報の範囲を自己の判断で選択するものとし、必要以上の個人情報を登録しないよう努めるものとします。<br />
                            3. ユーザーが他のユーザーとのメッセージ等を通じて自発的に開示した個人情報について、本サービス提供者は一切責任を負いません。
                        </P>
                    </Section>

                    <Section title="第10条（知的財産権）">
                        <P>
                            1. 本サービスに関する著作権・商標権その他の知的財産権は本サービス提供者または正当な権利者に帰属します。<br />
                            2. ユーザーが本サービスに投稿・アップロードしたコンテンツ（写真・テキスト等）については、当該コンテンツを本サービス提供者が本サービスの運営・改善・広告等の目的で無償・非独占的に利用する権利をユーザーは許諾するものとします。<br />
                            3. ユーザーは、自己が投稿するコンテンツが第三者の権利を侵害しないことを保証するものとします。権利侵害が生じた場合、ユーザーは本サービス提供者を補償するものとします。
                        </P>
                    </Section>

                    <Section title="第11条（反社会的勢力の排除）">
                        <P>
                            1. ユーザーは、現在および将来にわたって、暴力団・暴力団員・暴力団準構成員・暴力団関係企業・総会屋・社会運動等標ぼうゴロ・特殊知能暴力集団等（以下「反社会的勢力」といいます。）に該当しないことを表明し、保証するものとします。<br />
                            2. 本サービス提供者は、ユーザーが反社会的勢力に該当すると判断した場合、事前通知なく登録抹消その他必要な措置を講じることができます。これによってユーザーに損害が生じても、本サービス提供者は一切責任を負いません。
                        </P>
                    </Section>

                    <Section title="第12条（利用規約の変更）">
                        <P>
                            1. 本サービス提供者は、必要と判断した場合にはいつでも、ユーザーへの事前通知なく本規約を変更することができます。変更後の規約は、本サービス上に掲載した時点から効力を生じます。<br />
                            2. 規約変更後に本サービスを利用したユーザーは、変更後の規約に同意したものとみなします。
                        </P>
                    </Section>

                    <Section title="第13条（準拠法・管轄・時効）">
                        <P>
                            1. 本規約の解釈にあたっては、日本法を準拠法とします。<br />
                            2. 本サービスに関して紛争が生じた場合には、本サービス提供者の所在地を管轄する地方裁判所または簡易裁判所を第一審の専属的合意管轄裁判所とします。<br />
                            3. 本サービスに関する損害賠償請求権は、ユーザーが損害を知った日から1年、または損害発生日から2年のいずれか早い時点で時効消滅するものとします。
                        </P>
                    </Section>

                    <Box sx={{ mt: 4, p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                            本規約に定める免責・責任制限は、消費者契約法その他の強行法規により一部制限される場合があります。強行法規が優先する範囲においては、当該法規の定めに従います。
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </>
    );
}

export default Terms;
